import React from "react";

import styles from "./RadioButton.module.scss";

const RadioButton = ({
  register,
  label,
  isChecked,
  name,
  onChange,
  value,
  disabled = false,
}) => {
  return (
    <div className={styles.radio_btn}>
      <input
        {...register}
        type="radio"
        id={value}
        className={styles.custom_radio}
        style={{
          cursor: disabled ? "default" : "pointer",
          pointerEvents: disabled ? "none" : "auto",
        }}
        name={name}
        value={value}
        onChange={(e) =>
          onChange({ name: e.target.name, value: e.target.value })
        }
        checked={isChecked}
      />
      <label
        className={styles.radio_label}
        htmlFor={value}
        style={{
          cursor: disabled ? "default" : "pointer",
          pointerEvents: disabled ? "none" : "auto",
        }}
      ></label>
      <span className={styles.radio_name}>{label}</span>
    </div>
  );
};

export default RadioButton;
